import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { EventLinkedUserDetailFragmentDoc } from '../fragments/eventLinkedUser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllEventLinkedUsersQueryVariables = Types.Exact<{
  filter: Types.GetAllLinkedUserFilterInput;
}>;


export type GetAllEventLinkedUsersQuery = { __typename?: 'Query', getAllEventLinkedUsers: Array<{ __typename?: 'EventLinkedUser', id: string, user_name: string, password?: string | null, role?: string | null }> };


export const GetAllEventLinkedUsersDocument = gql`
    query GetAllEventLinkedUsers($filter: GetAllLinkedUserFilterInput!) {
  getAllEventLinkedUsers(filter: $filter) {
    ...EventLinkedUserDetail
  }
}
    ${EventLinkedUserDetailFragmentDoc}`;

/**
 * __useGetAllEventLinkedUsersQuery__
 *
 * To run a query within a React component, call `useGetAllEventLinkedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventLinkedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventLinkedUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllEventLinkedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAllEventLinkedUsersQuery, GetAllEventLinkedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventLinkedUsersQuery, GetAllEventLinkedUsersQueryVariables>(GetAllEventLinkedUsersDocument, options);
      }
export function useGetAllEventLinkedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventLinkedUsersQuery, GetAllEventLinkedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventLinkedUsersQuery, GetAllEventLinkedUsersQueryVariables>(GetAllEventLinkedUsersDocument, options);
        }
export type GetAllEventLinkedUsersQueryHookResult = ReturnType<typeof useGetAllEventLinkedUsersQuery>;
export type GetAllEventLinkedUsersLazyQueryHookResult = ReturnType<typeof useGetAllEventLinkedUsersLazyQuery>;
export type GetAllEventLinkedUsersQueryResult = Apollo.QueryResult<GetAllEventLinkedUsersQuery, GetAllEventLinkedUsersQueryVariables>;